<template>
  <div class="product-section-4 vi-container">

    <div class="main-container">

      <logo-header
        :logo-asset="departmentware"
      />

      <lead-title1
        main-title="FIRST CROWDFUNDING PLATFORM "
      />
      <lead-title2
        sub-title="IN MACEDONIA!"
      />

      <info-section6/>
    </div>


  </div>
</template>

<script>
import LogoHeader from "../components/LogoHeader";
import LeadTitle1 from "../components/sideMenu/LeadTitle1";
import LeadTitle2 from "../components/sideMenu/LeadTitle2";
import InfoSection4 from "./InfoSection4";
import InfoSection6 from "./InfoSection6";

export default {
  name: 'ProductSection4',
  components: {InfoSection6, InfoSection4, LeadTitle2, LeadTitle1, LogoHeader},


  data: () => ({
    departmentware: require('../assets/logos/e-crowd.png'),
  })
}

</script>

<style lang="scss">
@import "ProductSection4.scss";
</style>
